<template>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-title style="font-size: 27px;font-weight: 500;">กิจกรรม</v-title>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <!-- <v-btn
              color="#1B437C"
              dark
              depressed
              @click="dialogCreateQuestion = true"
              v-if="
                $session.getAll().data.shopId ===
                'U4e23f7bf31b362622ff7c5c06dfdf350'
              "
            >
              <v-icon left>mdi-plus-box-multiple</v-icon>
              เลือกแบบสอบถาม
            </v-btn> -->
            <v-btn color="#1B437C" dark depressed @click="dialogAdd = true">
              <v-icon left>mdi-plus-box-multiple</v-icon>
              เพิ่มกิจกรรม
            </v-btn>
          </v-col>
        </v-row>
        <v-row style="height: 900px">
          <!-- Create Question -->
          <v-dialog
            v-model="dialogCreateQuestion"
            max-width="50%"
            max-height="50%"
          >
            <v-card>
              <v-card-title class="pa-2" style="border-bottom: solid #e8e7e7">
                <span class="ml-2">สร้างแบบสอบถาม</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <div class="mb-3">
                        - กรุณาเลือก 1 กิจกรรมสำหรับแบบสอบถาม
                      </div>
                      <v-card min-height="300">
                        <v-data-table
                          :headers="columns2"
                          :items="
                            dataItem.filter(
                              (item) =>
                                item.answerType ===
                                  'คำตอบแบบมากกว่า 1 ตัวเลือก' ||
                                item.answerType === 'คำตอบแบบ 1 ตัวเลือก',
                            )
                          "
                          :search="searchAll2"
                          :items-per-page="10"
                          dense
                        >
                          <template v-slot:[`item.answerType`]="{ item }">
                            {{
                              item.answerType !== "คำตอบแบบข้อความ" &&
                              item.answerType !==
                                "คำตอบแบบมากกว่า 1 ตัวเลือก" &&
                              item.answerType !== "คำตอบแบบ 1 ตัวเลือก"
                                ? "รับคะแนนฟรี"
                                : item.answerType
                            }}
                          </template>
                          <template
                            v-if="
                              $session.getAll().data.shopId ===
                              'U4e23f7bf31b362622ff7c5c06dfdf350'
                            "
                            v-slot:[`item.bvpStatusQuestionnaire`]="{ item }"
                          >
                            <v-checkbox
                              v-if="item.answerType !== null"
                              v-model="item.bvpStatusQuestionnaire"
                              :label="`เลือกแบบสอบถาม`"
                              on-icon="mdi-check-circle"
                              off-icon="mdi-close-circle"
                              @change="
                                changQuestion(
                                  item.bvpStatusQuestionnaire,
                                  item.activityId,
                                  item.answerType,
                                )
                              "
                            >
                            </v-checkbox>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <div class="mb-3">
                        - กรุณาเลือก 1 กิจกรรมสำหรับแบบสอบถาม
                      </div>
                      <v-card min-height="300">
                        <v-data-table
                          :headers="columns2"
                          :items="
                            dataItem.filter(
                              (item) => item.answerType === 'คำตอบแบบข้อความ',
                            )
                          "
                          :search="searchAll2"
                          :items-per-page="10"
                          dense
                        >
                          <template v-slot:[`item.answerType`]="{ item }">
                            {{
                              item.answerType !== "คำตอบแบบข้อความ" &&
                              item.answerType !==
                                "คำตอบแบบมากกว่า 1 ตัวเลือก" &&
                              item.answerType !== "คำตอบแบบ 1 ตัวเลือก"
                                ? "รับคะแนนฟรี"
                                : item.answerType
                            }}
                          </template>
                          <template
                            v-if="
                              $session.getAll().data.shopId ===
                              'U4e23f7bf31b362622ff7c5c06dfdf350'
                            "
                            v-slot:[`item.bvpStatusQuestionnaire`]="{ item }"
                          >
                            <v-checkbox
                              v-if="item.answerType !== null"
                              v-model="item.bvpStatusQuestionnaire"
                              :label="`เลือกแบบสอบถาม`"
                              on-icon="mdi-check-circle"
                              off-icon="mdi-close-circle"
                              @change="
                                changQuestion(
                                  item.bvpStatusQuestionnaire,
                                  item.activityId,
                                  item.answerType,
                                )
                              "
                            >
                            </v-checkbox>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- ADD -->
          <v-dialog
            v-model="dialogAdd"
            persistent
            :max-width="resCol === '12' ? '' : '50%'"
            :fullscreen="resCol === '12' ? true : false"
          >
            <v-card>
              <div>
                <v-card-text>
                  <v-container>
                    <div style="margin-bottom: 30px;">
                      <div>
                        <v-card-title class="justify-space-between" style="font-size:23px">
                          เพิ่มกิจกรรม
                          <v-btn
                            small
                            icon
                            color="#E0E0E0"
                            @click="closeDialodActivity()"
                          >
                            <v-icon color="#FE4A01">mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>
                      </div>
                    </div>
                    <v-row justify="center">
                      <v-col cols="12">
                        <div v-show="secoundStep === null || secoundStep === ''">
                          <h4
                            style="
                              color: black;
                              font-weight: bold;
                              margin-bottom: 20px;
                              padding-left: 0;
                              font-weight: bold;
                            "
                          >
                            เลือกรูปแบบกิจกรรม
                          </h4>
                          <v-row class="mb-5">
                            <v-col v-for="(item, i) in selectType" :key="i">
                              <v-card
                                elevation="0"
                                height="120"
                                style="display: flex;align-items: center;justify-content: center;;"
                                @click="
                                  (formAdd.type = item.value), changColor(item);
                                "
                                :class="
                                  formAdd.type === item.value
                                    ? 'activeCard'
                                    : 'not-activeCard'
                                "
                              >
                                <span>
                                  <v-icon :color="item.color" class="iconja">{{
                                    item.icon
                                  }}</v-icon>
                                  <h4
                                    :style="
                                      formAdd.type === item.value
                                        ? 'font-weight: bold;color:#1b437c;'
                                        : 'font-weight: bold;color: grey;'
                                    "
                                    class="mb-0"
                                  >
                                    {{ item.text }}
                                  </h4>
                                </span>
                              </v-card>
                            </v-col>
                          </v-row>
                          <div class="d-flex justify-end">
                            <v-btn large outlined color="#1B437C" :disabled="formAdd.type === null || formAdd.type === ''" text @click="(secoundStep = formAdd.type)">ต่อไป<v-icon>mdi:chevron-right</v-icon></v-btn>
                          </div>
                        </div>
                        <!-- กรอกข้อมูล -->
                        <div v-if="secoundStep === 'กรอกข้อมูล'">
                          <div>
                            <h4
                              v-show="!thirdStep"
                              style="
                                color: black;
                                font-weight: bold;
                                margin-bottom: 20px;
                                padding-left: 0;
                                font-weight: bold;
                              "
                            >
                              เลือกรูปแบบคำตอบ
                            </h4>
                            <v-row class="mb-5" v-show="!thirdStep">
                              <v-col v-for="(item, i) in answerTypeList" :key="i">
                                <v-card
                                  elevation="0"
                                  height="120"
                                  style="display: flex;align-items: center;justify-content: center;;"
                                  @click="
                                    clearDataActivity(), (formAdd.answerType = item)
                                  "
                                  :class="
                                    formAdd.answerType === item
                                      ? 'activeCard'
                                      : 'not-activeCard'
                                  "
                                >
                                  <span>
                                    <v-icon v-if="i === 0" x-small style="font-size: 29px !important" :color="formAdd.answerType === 'คำตอบแบบข้อความ' ? '#1b437c' : 'grey' " class="iconja">mdi-format-text</v-icon>
                                    <v-icon v-if="i === 1" x-small style="font-size: 29px !important" :color="formAdd.answerType === 'คำตอบแบบ 1 ตัวเลือก' ? '#1b437c' : 'grey' " class="iconja">mdi-radiobox-marked</v-icon>
                                    <v-icon v-if="i === 2" x-small style="font-size: 29px !important" :color="formAdd.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก' ? '#1b437c' : 'grey' " class="iconja">mdi-checkbox-marked</v-icon>
                                    <h4
                                      :style="
                                        formAdd.answerType === item
                                          ? 'font-weight: bold;color:#1b437c;'
                                          : 'font-weight: bold;color: grey;'
                                      "
                                      class="mb-0"
                                    >
                                      {{ item }}
                                    </h4>
                                  </span>
                                </v-card>
                              </v-col>
                            </v-row>
                          </div>
                          <!-- thirdStep -->
                          <div v-if="thirdStep === true">
                            <v-form ref="form_add3" v-model="validAdd3" lazy-validation>
                              <v-card
                                elevation="0"
                                class="pa-4"
                              >
                                <div>
                                  <h3 style="font-weight: bold; color: #1b437c;text-align: center;">
                                    ข้อมูลกิจกรรม
                                  </h3>
                                  <v-text-field
                                    class="pa-0"
                                    v-model="formAdd.title"
                                    :rules="required"
                                    label="ชื่อกิจกรรม"
                                    required
                                    placeholder="ชื่อกิจกรรม"
                                    outlined
                                    dense
                                  ></v-text-field>
                                  <v-text-field
                                    class="pa-0"
                                    v-model="formAdd.titleEng"
                                    label="ชื่อกิจกรรมภาษาอังกฤษ"
                                    placeholder="ชื่อกิจกรรมภาษาอังกฤษ"
                                    outlined
                                    dense
                                  ></v-text-field>
                                  <v-col
                                    cols="12"
                                    class="pa-0"
                                    v-if="
                                      formAdd.type === 'FreeCoin' ||
                                      formAdd.type === 'LuckyDraw' ||
                                      formAdd.type === 'video'
                                    "
                                  >
                                    <v-select
                                      class="pa-0"
                                      v-model="formAdd.repeats"
                                      :items="selectRepeat"
                                      :rules="required"
                                      required
                                      label="การทำซ้ำ"
                                      placeholder="การทำซ้ำ"
                                      outlined
                                      dense
                                    ></v-select>
                                  </v-col>
                                </div>
                                <h4>
                                  <span style="font-weight: 500;" class="mr-3">วันหมดอายุกิจกรรม</span><span style="color: #1b437c;font-weight: 100;">*</span>
                                </h4>
                                <div>
                                  <div>
                                    <v-radio-group v-model="typeExpire" hide-details>
                                  <v-row>
                                    <v-col cols="6">
                                      <v-radio
                                        style="padding: 9px;border: solid #75757533 2px;border-radius: 9px;width: 100%;"
                                        label="มีวันสิ้นสุดกิจกรรม"
                                        value="มีวันสิ้นสุดกิจกรรม"
                                      ></v-radio>
                                    </v-col>
                                    <v-col cols="6">
                                      <v-radio
                                        style="padding: 9px;border: solid #75757533 2px;border-radius: 9px;width: 100%;"
                                        label="ไม่มีวันสิ้นสุดกิจกรรม"
                                        value="ไม่มีวันสิ้นสุดกิจกรรม"
                                      ></v-radio>
                                    </v-col>
                                  </v-row>
                                </v-radio-group>
                                  </div>
                                  <v-row
                                    v-if="typeExpire === 'มีวันสิ้นสุดกิจกรรม'"
                                    class="mt-4"
                                  >
                                    <v-col cols="6">
                                      <v-menu
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                      >
                                     {{formAdd.field1Title }}
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field
                                            class="pa-0"
                                            v-model="formAdd.startDate"
                                            placeholder="วันที่เริ่ม"
                                            prepend-inner-icon="mdi-calendar"
                                            v-bind="attrs"
                                            hide-details
                                            label="วันที่เริ่ม"
                                            :rules="required"
                                            outlined
                                            dense
                                            v-on="on"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="formAdd.startDate"
                                          @input="menu = false"
                                        ></v-date-picker>
                                      </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                      <v-menu
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                      >
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field
                                            class="pa-0"
                                            v-model="formAdd.endDate"
                                            placeholder="วันที่สิ้นสุด"
                                            prepend-inner-icon="mdi-calendar"
                                            v-bind="attrs"
                                            :rules="required"
                                            hide-details
                                            dense
                                            label="วันที่สิ้นสุด"
                                            outlined
                                            v-on="on"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="formAdd.endDate"
                                          @input="menu2 = false"
                                        ></v-date-picker>
                                      </v-menu>
                                    </v-col>
                                  </v-row>
                                  <v-row
                                    v-if="typeExpire === 'ไม่มีวันสิ้นสุดกิจกรรม'"
                                    class="mt-4"
                                  >
                                    <v-col cols="12">
                                      <v-menu
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                      >
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field
                                            class="pa-0"
                                            v-model="formAdd.startDate"
                                            placeholder="วันที่เริ่ม"
                                            prepend-inner-icon="mdi-calendar"
                                            v-bind="attrs"
                                            label="วันที่เริ่ม"
                                            :rules="required"
                                            outlined
                                            hide-details
                                            dense
                                            v-on="on"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="formAdd.startDate"
                                          @input="menu = false"
                                        ></v-date-picker>
                                      </v-menu>
                                    </v-col>
                                  </v-row>
                                </div>
                                <h4 class="my-5">
                                  <span style="font-weight: 500;" class="mr-3">ผู้เข้าร่วมกิจกรรม</span><span style="color: #1b437c;font-weight: 100;">*</span>
                                </h4>
                                <div>
                                  <v-radio-group
                                    v-model="inline"
                                    class="mt-1 mb-4"
                                    :rules="required"
                                    hide-details
                                  >
                                    <v-row>
                                      <v-col cols="6">
                                        <v-radio
                                          style="padding: 9px;border: solid #75757533 2px;border-radius: 9px;width: 100%;"
                                          label="จำกัดจำนวนคนเข้าร่วม"
                                          value="จำกัดจำนวนคนเข้าร่วม"
                                        ></v-radio>
                                      </v-col>
                                      <v-col cols="6">
                                        <v-radio
                                          style="padding: 9px;border: solid #75757533 2px;border-radius: 9px;width: 100%;"
                                          label="ไม่จำกัดจำนวนคนเข้าร่วม"
                                          value="ไม่จำกัดจำนวนคนเข้าร่วม"
                                        ></v-radio>
                                      </v-col>
                                    </v-row>
                                  </v-radio-group>
                                  <v-row v-if="inline">
                                    <v-col
                                      cols="12"
                                      v-if="inline === 'จำกัดจำนวนคนเข้าร่วม'"
                                    >
                                      <VuetifyMoney
                                        class="pa-0"
                                        v-model="formAdd.quota"
                                        label="จำกัดจำนวนคนเข้าร่วม"
                                        outlined
                                        dense
                                        :rules="required"
                                        required
                                        v-bind:options="options2"
                                        hide-details
                                      />
                                    </v-col>
                                    <v-col
                                      cols="12"
                                    >
                                      <h4 class="mb-5 mt-0">
                                        <span style="font-weight: 500;" class="mr-3">คะแนนที่ได้รับ</span><span style="color: #1b437c;font-weight: 100;">*</span>
                                      </h4>
                                      <VuetifyMoney
                                        class="pa-0"
                                        v-model="formAdd.coin"
                                        label="คะแนนที่ได้รับ"
                                        placeholder="คะแนนที่ได้รับ"
                                        outlined
                                        dense
                                        :rules="[rules.moreThanZero]"
                                        required
                                        v-bind:options="options2"
                                        v-if="formAdd.type != 'LuckyDraw'"
                                      />
                                    </v-col>
                                    <v-col cols="12" class="px-0">
                                      <v-col class="pa-0">
                                        <!-- <v-row justify="center">
                                          <v-btn
                                            class="white--text"
                                            elevation="2"
                                            x-large
                                            block
                                            color="#173053"
                                            :disabled="!validAdd || formAdd.pictureUrlPreview === '' || !formAdd.pictureUrlPreview"
                                            :loading="loadingAdd"
                                            @click="addData()"
                                          >
                                            <v-icon left>mdi-checkbox-marked-circle</v-icon>
                                            บันทึก
                                          </v-btn>
                                        </v-row> -->
                                        <!-- อันแรก -->
                                        <div class="d-flex justify-space-between">
                                          <v-btn large outlined color="#1B437C" @click="thirdStep = false"><v-icon>mdi-chevron-left</v-icon>ย้อนกลับ</v-btn>
                                          <v-btn large outlined color="#1B437C" :disabled="!validAdd3" @click="validateFromAdd3">บันทึก</v-btn>
                                        </div>
                                      </v-col>
                                    </v-col>
                                  </v-row>
                                </div>
                              </v-card>
                            </v-form>
                          </div>
                          <!-- เลือกรูปแบบตอบคำถาม -->
                          <div v-if="formAdd.type === 'กรอกข้อมูล'">
                            <!-- แบบ text -->
                            <v-card
                              v-if="formAdd.answerType === 'คำตอบแบบข้อความ' && thirdStep !== true"
                              elevation="0"
                              class="pa-4"
                            >
                              <v-card-text v-if="loadingInsert === true">
                                <v-progress-circular
                                  indeterminate
                                  size="64"
                                ></v-progress-circular>
                              </v-card-text>
                              <v-card-text v-if="loadingInsert === false">
                                <v-form ref="form_add2" v-model="validAdd2" lazy-validation>
                                  <div style="padding: 16px">
                                    <div style="display: flex; margin-bottom: 10px">
                                      <h4 style="color: red">*</h4>
                                      <h4
                                        class="ml-3 mb-3"
                                        style="
                                          height: 20px;
                                          font-weight: bold;
                                          text-align: left;
                                          margin: 0px !important;
                                        "
                                      >
                                        คำถามที่ 1
                                      </h4>
                                    </div>
                                    <v-row>
                                      <v-col
                                        class="mt pa-0"
                                        cols="12"
                                        style="height: 75px"
                                      >
                                        <v-text-field
                                          class="pb-0"
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field1Title[0]"
                                          placeholder="ชื่อข้อมูล"
                                          :rules="required"
                                          required
                                          label="ชื่อข้อมูล"
                                          outlined
                                          dense
                                          hide-details
                                        ></v-text-field>
                                      </v-col>
                                      <v-col
                                        class="mt pa-0"
                                        cols="12"
                                        style="height: 75px"
                                      >
                                        <v-text-field
                                          class="pb-0"
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field1Title[1]"
                                          placeholder="ชื่อข้อมูลภาษาอังกฤษ"
                                          label="ชื่อข้อมูลภาษาอังกฤษ"
                                          outlined
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" class="pa-0">
                                        <v-select
                                          class="pt-0"
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field1Type"
                                          :items="selectTypeField"
                                          :rules="required"
                                          placeholder="ประเภทกรอกข้อมูล"
                                          label="ประเภทการกรอกข้อมูล"
                                          outlined
                                          dense
                                          :menu-props="{
                                            bottom: true,
                                            offsetY: true,
                                          }"
                                        ></v-select>
                                      </v-col>
                                      <v-row
                                        class="ml-5"
                                        :rules="required"
                                      >
                                        <v-col>
                                          <v-switch
                                            v-model="formAdd.chkbox1"
                                            label="บังคับกรอกข้อมูล"
                                            inset
                                          >
                                          </v-switch>
                                        </v-col>
                                      </v-row>
                                    </v-row>
                                  </div>
                                  <v-divider></v-divider>
                                  <div
                                    v-if="countQuestion >= 2"
                                    style="padding: 16px"
                                  >
                                    <div
                                      style="
                                        display: flex;
                                        justify-content: space-between;
                                        margin-bottom: 20px;
                                      "
                                    >
                                      <h4
                                        class="ml-3"
                                        style="
                                          height: 20px;
                                          font-weight: bold;
                                          text-align: left;
                                          margin: 0px !important;
                                        "
                                      >
                                        คำถามที่ 2
                                      </h4>
                                      <v-btn
                                        fab
                                        x-small
                                        color="red"
                                        dark
                                        @click="clearData2(), countQuestion--"
                                        ><v-icon dark>mdi-minus</v-icon></v-btn
                                      >
                                    </div>
                                    <v-row>
                                      <v-col
                                        class="mt pa-0"
                                        cols="12"
                                        style="height: 75px"
                                      >
                                        <v-text-field
                                          class="pb-0"
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field2Title[0]"
                                          placeholder="ชื่อข้อมูล"
                                          :rules="required"
                                          required
                                          label="ชื่อข้อมูล"
                                          outlined
                                          hide-details
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                      <v-col
                                        class="mt pa-0"
                                        cols="12"
                                        style="height: 75px"
                                      >
                                        <v-text-field
                                          class="pb-0"
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field2Title[1]"
                                          placeholder="ชื่อข้อมูลภาษาอังกฤษ"
                                          label="ชื่อข้อมูลภาษาอังกฤษ"
                                          outlined
                                          hide-details
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" class="pa-0">
                                        <v-select
                                          class="pt-0"
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field2Type"
                                          :items="selectTypeField"
                                          placeholder="ประเภทกรอกข้อมูล"
                                          label="ประเภทการกรอกข้อมูล"
                                          outlined
                                          :rules="required"
                                          required
                                          dense
                                          :menu-props="{
                                            bottom: true,
                                            offsetY: true,
                                          }"
                                        ></v-select>
                                      </v-col>
                                      <v-row
                                        class="ml-5"
                                        :rules="required"
                                      >
                                        <v-col>
                                          <v-switch
                                            v-model="formAdd.chkbox2"
                                            label="บังคับกรอกข้อมูล"
                                            inset
                                          >
                                          </v-switch>
                                        </v-col>
                                      </v-row>
                                    </v-row>
                                    <v-divider></v-divider>
                                  </div>
                                  <div
                                    v-if="countQuestion >= 3"
                                    style="padding: 16px"
                                  >
                                    <div
                                      style="
                                        display: flex;
                                        justify-content: space-between;
                                        margin-bottom: 20px;
                                      "
                                    >
                                      <h4
                                        class="ml-3"
                                        style="
                                          height: 20px;
                                          font-weight: bold;
                                          text-align: left;
                                          margin: 0px !important;
                                        "
                                      >
                                        คำถามที่ 3
                                      </h4>
                                      <v-btn
                                        fab
                                        x-small
                                        color="red"
                                        dark
                                        @click="clearData3(), countQuestion--"
                                        ><v-icon dark>mdi-minus</v-icon></v-btn
                                      >
                                    </div>
                                    <v-row>
                                      <v-col
                                        class="mt pa-0"
                                        cols="12"
                                        style="height: 75px"
                                      >
                                        <v-text-field
                                          class="pb-0"
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field3Title[0]"
                                          :rules="required"
                                          required
                                          placeholder="ชื่อข้อมูล"
                                          label="ชื่อข้อมูล"
                                          outlined
                                          dense
                                          hide-details
                                        ></v-text-field>
                                      </v-col>
                                      <v-col
                                        class="mt pa-0"
                                        cols="12"
                                        style="height: 75px"
                                      >
                                        <v-text-field
                                          class="pb-0"
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field3Title[1]"
                                          placeholder="ชื่อข้อมูลภาษาอังกฤษ"
                                          label="ชื่อข้อมูลภาษาอังกฤษ"
                                          outlined
                                          dense
                                          hide-details
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" class="pa-0">
                                        <v-select
                                          class="pt-0"
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field3Type"
                                          :items="selectTypeField"
                                          placeholder="ประเภทกรอกข้อมูล"
                                          :rules="required"
                                          required
                                          label="ประเภทการกรอกข้อมูล"
                                          outlined
                                          :menu-props="{
                                            bottom: true,
                                            offsetY: true,
                                          }"
                                          dense
                                        ></v-select>
                                      </v-col>
                                      <v-row
                                        class="ml-5"
                                        :rules="required"
                                      >
                                        <v-col>
                                          <v-switch
                                            v-model="formAdd.chkbox3"
                                            label="บังคับกรอกข้อมูล"
                                          >
                                          </v-switch>
                                        </v-col>
                                      </v-row>
                                    </v-row>
                                    <v-divider></v-divider>
                                  </div>
                                  <div
                                    v-if="countQuestion >= 4"
                                    style="padding: 16px"
                                  >
                                    <div
                                      style="
                                        display: flex;
                                        justify-content: space-between;
                                        margin-bottom: 20px;
                                      "
                                    >
                                      <h4
                                        class="ml-3"
                                        style="
                                          height: 20px;
                                          font-weight: bold;
                                          text-align: left;
                                          margin: 0px !important;
                                        "
                                      >
                                        คำถามที่ 4
                                      </h4>
                                      <v-btn
                                        fab
                                        x-small
                                        color="red"
                                        dark
                                        @click="countQuestion--, clearData4()"
                                        ><v-icon dark>mdi-minus</v-icon></v-btn
                                      >
                                    </div>
                                    <v-row>
                                      <v-col
                                        class="mt pa-0"
                                        cols="12"
                                        style="height: 75px"
                                      >
                                        <v-text-field
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field4Title[0]"
                                          placeholder="ชื่อข้อมูล"
                                          label="ชื่อข้อมูล"
                                          :rules="required"
                                          required
                                          outlined
                                          hide-details
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                      <v-col
                                        class="mt pa-0"
                                        cols="12"
                                        style="height: 75px"
                                      >
                                        <v-text-field
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field4Title[1]"
                                          placeholder="ชื่อข้อมูลภาษาอังกฤษ"
                                          label="ชื่อข้อมูลภาษาอังกฤษ"
                                          outlined
                                          hide-details
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" class="pa-0">
                                        <v-select
                                          class="pt-0"
                                          background-color="#f2f4f9"
                                          v-model="formAdd.field4Type"
                                          :items="selectTypeField"
                                          :rules="required"
                                          required
                                          placeholder="ประเภทกรอกข้อมูล"
                                          :menu-props="{
                                            bottom: true,
                                            offsetY: true,
                                          }"
                                          label="ประเภทการกรอกข้อมูล"
                                          outlined
                                          hide-details
                                          dense
                                        ></v-select> </v-col
                                      ><v-row
                                        class="ml-5"
                                        :rules="required"
                                      >
                                        <v-col>
                                          <v-checkbox
                                            v-model="formAdd.chkbox4"
                                            label="บังคับกรอกข้อมูล"
                                          >
                                          </v-checkbox>
                                        </v-col>
                                      </v-row>
                                    </v-row>
                                    <v-divider></v-divider>
                                  </div>
                                </v-form>
                                <v-btn
                                  block
                                  dark
                                  color="#1B437C"
                                  style="border-radius: 10px"
                                  :disabled="countQuestion === 4"
                                  @click="countQuestion++"
                                  >เพิ่มคำถาม
                                </v-btn>
                                <div class="d-flex justify-space-between mt-7">
                                  <v-btn large outlined color="#1B437C" @click="clearDataAdd"><v-icon>mdi-chevron-left</v-icon>ย้อนกลับ</v-btn>
                                  <v-btn large outlined color="#1B437C" :disabled="!validAdd2" @click="validateFrom">ต่อไป<v-icon>mdi-chevron-right</v-icon></v-btn>
                                </div>
                              </v-card-text>
                            </v-card>
                            <!-- แบบ choice -->
                            <v-card
                              v-if="
                                (formAdd.answerType === 'คำตอบแบบ 1 ตัวเลือก' ||
                                formAdd.answerType ===
                                  'คำตอบแบบมากกว่า 1 ตัวเลือก') && thirdStep !== true
                              "
                              elevation="0"
                              class="pa-4"
                            >
                              <v-card-text v-if="loadingInsert === true">
                                <v-progress-circular
                                  indeterminate
                                  size="64"
                                ></v-progress-circular>
                              </v-card-text>
                              <v-card-text v-if="loadingInsert === false">
                                <!-- <div style="text-align: end">
                                  <v-btn
                                    rounded
                                    small
                                    color="green"
                                    style="color: white"
                                    @click="addQuestion"
                                  >
                                    เพิ่มคำถาม
                                    <v-icon color="white"> mdi-plus </v-icon>
                                  </v-btn>
                                </div> -->
                              <v-form  ref="form_add2" v-model="validAdd2" lazy-validation>
                                <div
                                  v-for="(item, i) in formAdd.answerChoice"
                                  :key="i"
                                  class="pa-0"
                                  cols="12"
                                  align="center"
                                >
                                  <v-divider class="my-5" v-if="i !== 0"></v-divider>
                                  <div class="d-flex justify-space-between">
                                    <h4 style="text-align: left; font-weight: bold">
                                      คำถามข้อที่ {{ i + 1 }}
                                    </h4>
                                    <div style="position: relative;top: -10px;"><v-btn fab icon small color="red" v-if="i !== 0" @click="deleteQuetiion(i)"><v-icon>mdi-delete</v-icon></v-btn></div>
                                  </div>
                                  <v-text-field
                                    v-model="item[0]"
                                    :rules="required"
                                    class="pa-0 mb-3"
                                    :placeholder="
                                      'ชื่อคำถาม ' + (i + 1) + ' (ภาษาไทย)'
                                    "
                                    :label="'ชื่อคำถาม ' + (i + 1) + ' (ภาษาไทย)'"
                                    outlined
                                    hide-details
                                    dense
                                  ></v-text-field>
                                  <v-text-field
                                    v-model="answerChoiceEng[i][0]"
                                    class="pa-0 mb-3"
                                    :placeholder="
                                      'ชื่อคำถาม ' + (i + 1) + ' (ภาษาอังกฤษ)'
                                    "
                                    :label="'ชื่อคำถาม ' + (i + 1) + ' (ภาษาอังกฤษ)'"
                                    outlined
                                    hide-details
                                    dense
                                  ></v-text-field>
                                  <h5 style="text-align: left; font-weight: bold">
                                    ตัวเลือกคำตอบ
                                  </h5>
                                  <v-select
                                    :items="number"
                                    label="จำนวนคำตอบ"
                                    outlined
                                    dense
                                    :rules="required"
                                    @change="(value) => addChoice2(value, i, item)"
                                    :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                    }"
                                  />
                                  <v-row
                                    v-for="(item2, index) in item.length - 1"
                                    :key="index" class="px-3"
                                  >
                                    <v-col cols="6" class="pa-1 d-flex">
                                      <p style="font-size: 19px;display: flex;align-items: center;margin-right: 7px;margin-bottom: 6px;">{{index + 1}}.</p>
                                      <v-text-field
                                        v-model="item[index + 1]"
                                        class="mb-2"
                                        :rules="required"
                                        :placeholder="
                                          'คำตอบ ' + (index + 1) + ' (ภาษาไทย)'
                                        "
                                        :label="
                                          'คำตอบ ' + (index + 1) + ' (ภาษาไทย)'
                                        "
                                        @click:append="toggleMarker(item2, item)"
                                        outlined
                                        hide-details
                                        dense
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="pa-1">
                                      <v-text-field
                                        v-model="answerChoiceEng[i][index + 1]"
                                        class="mb-0"
                                        :placeholder="
                                          'คำตอบ ' +
                                          (index + 1) +
                                          ' (ภาษาอังกฤษ)'
                                        "
                                        :label="
                                          'คำตอบ ' +
                                          (index + 1) +
                                          ' (ภาษาอังกฤษ)'
                                        "
                                        @click:append="toggleMarker(item2, item)"
                                        outlined
                                        hide-details
                                        dense
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <!-- <v-btn
                                    dark
                                    @click="addChoice(item, i)"
                                    color="primary"
                                  >
                                    เพิ่มตัวเลือก
                                  </v-btn> -->
                                </div>
                                <div style="text-align: end;margin-top: 20px;">
                                  <v-btn
                                    block
                                    color="#1B437C"
                                    style="color: white"
                                    @click="addQuestion"
                                  >
                                    <v-icon color="white"> mdi-plus </v-icon>
                                    เพิ่มคำถาม
                                  </v-btn>
                                </div>
                              </v-form>
                                <div class="d-flex justify-space-between mt-7">
                                  <v-btn large outlined color="#1B437C" @click="clearDataAdd"><v-icon>mdi-chevron-left</v-icon>ย้อนกลับ</v-btn>
                                  <v-btn large outlined color="#1B437C" :disabled="!validAdd2" @click="validateFrom">ต่อไป<v-icon>mdi-chevron-right</v-icon></v-btn>
                                </div>
                              </v-card-text>
                              <!-- <v-divider v-if="loadingInsert === false"></v-divider> -->
                            </v-card>
                          </div>
                        </div>
                        <!-- รับคะแนนฟรี -->
                        <div v-if="secoundStep === 'FreeCoin'">
                          <v-form ref="form_add" v-model="validAdd" lazy-validation>
                            <v-card
                              elevation="0"
                              class="pa-4"
                            >
                              <div>
                                <h3 style="font-weight: bold; color: #1b437c;text-align: center;">
                                  ข้อมูลกิจกรรม
                                </h3>
                                <v-text-field
                                  class="pa-0"
                                  v-model="formAdd.title"
                                  :rules="required"
                                  label="ชื่อกิจกรรม"
                                  required
                                  placeholder="ชื่อกิจกรรม"
                                  outlined
                                  dense
                                ></v-text-field>
                                <v-text-field
                                  class="pa-0"
                                  v-model="formAdd.titleEng"
                                  label="ชื่อกิจกรรมภาษาอังกฤษ"
                                  placeholder="ชื่อกิจกรรมภาษาอังกฤษ"
                                  outlined
                                  dense
                                ></v-text-field>
                                <v-col
                                  cols="12"
                                  class="pa-0"
                                  v-if="
                                    formAdd.type === 'FreeCoin' ||
                                    formAdd.type === 'LuckyDraw' ||
                                    formAdd.type === 'video'
                                  "
                                >
                                  <v-select
                                    class="pa-0"
                                    v-model="formAdd.repeats"
                                    :items="selectRepeat"
                                    :rules="required"
                                    required
                                    label="การทำซ้ำ"
                                    placeholder="การทำซ้ำ"
                                    outlined
                                    dense
                                  ></v-select>
                                </v-col>
                              </div>
                              <h4>
                                <span style="font-weight: 500;" class="mr-3">วันหมดอายุกิจกรรม</span><span style="color: #1b437c;font-weight: 100;">*</span>
                              </h4>
                              <div>
                                <div>
                                  <v-radio-group v-model="typeExpire" hide-details>
                                <v-row>
                                  <v-col cols="6">
                                    <v-radio
                                      style="padding: 9px;border: solid #75757533 2px;border-radius: 9px;width: 100%;"
                                      label="มีวันสิ้นสุดกิจกรรม"
                                      value="มีวันสิ้นสุดกิจกรรม"
                                    ></v-radio>
                                  </v-col>
                                  <v-col cols="6">
                                    <v-radio
                                      style="padding: 9px;border: solid #75757533 2px;border-radius: 9px;width: 100%;"
                                      label="ไม่มีวันสิ้นสุดกิจกรรม"
                                      value="ไม่มีวันสิ้นสุดกิจกรรม"
                                    ></v-radio>
                                  </v-col>
                                </v-row>
                              </v-radio-group>
                                </div>
                                <v-row
                                  v-if="typeExpire === 'มีวันสิ้นสุดกิจกรรม'"
                                  class="mt-4"
                                >
                                  <v-col cols="6">
                                    <v-menu
                                      v-model="menu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                          class="pa-0"
                                          v-model="formAdd.startDate"
                                          placeholder="วันที่เริ่ม"
                                          prepend-inner-icon="mdi-calendar"
                                          v-bind="attrs"
                                          hide-details
                                          label="วันที่เริ่ม"
                                          :rules="required"
                                          outlined
                                          dense
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="formAdd.startDate"
                                        @input="menu = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-col>
                                  <v-col cols="6">
                                    <v-menu
                                      v-model="menu2"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                          class="pa-0"
                                          v-model="formAdd.endDate"
                                          placeholder="วันที่สิ้นสุด"
                                          prepend-inner-icon="mdi-calendar"
                                          v-bind="attrs"
                                          :rules="required"
                                          hide-details
                                          dense
                                          label="วันที่สิ้นสุด"
                                          outlined
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="formAdd.endDate"
                                        @input="menu2 = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-col>
                                </v-row>
                                <v-row
                                  v-if="typeExpire === 'ไม่มีวันสิ้นสุดกิจกรรม'"
                                  class="mt-4"
                                >
                                  <v-col cols="12">
                                    <v-menu
                                      v-model="menu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                          class="pa-0"
                                          v-model="formAdd.startDate"
                                          placeholder="วันที่เริ่ม"
                                          prepend-inner-icon="mdi-calendar"
                                          v-bind="attrs"
                                          label="วันที่เริ่ม"
                                          :rules="required"
                                          outlined
                                          hide-details
                                          dense
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="formAdd.startDate"
                                        @input="menu = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-col>
                                </v-row>
                              </div>
                              <h4 class="my-5">
                                <span style="font-weight: 500;" class="mr-3">ผู้เข้าร่วมกิจกรรม</span><span style="color: #1b437c;font-weight: 100;">*</span>
                              </h4>
                              <div>
                                <v-radio-group
                                  v-model="inline"
                                  class="mt-1 mb-4"
                                  :rules="required"
                                  hide-details
                                >
                                  <v-row>
                                    <v-col cols="6">
                                      <v-radio
                                        style="padding: 9px;border: solid #75757533 2px;border-radius: 9px;width: 100%;"
                                        label="จำกัดจำนวนคนเข้าร่วม"
                                        value="จำกัดจำนวนคนเข้าร่วม"
                                      ></v-radio>
                                    </v-col>
                                    <v-col cols="6">
                                      <v-radio
                                        style="padding: 9px;border: solid #75757533 2px;border-radius: 9px;width: 100%;"
                                        label="ไม่จำกัดจำนวนคนเข้าร่วม"
                                        value="ไม่จำกัดจำนวนคนเข้าร่วม"
                                      ></v-radio>
                                    </v-col>
                                  </v-row>
                                </v-radio-group>
                                <v-row v-if="inline">
                                  <v-col
                                    cols="12"
                                    v-if="inline === 'จำกัดจำนวนคนเข้าร่วม'"
                                  >
                                    <VuetifyMoney
                                      class="pa-0"
                                      v-model="formAdd.quota"
                                      label="จำกัดจำนวนคนเข้าร่วม"
                                      outlined
                                      dense
                                      :rules="required"
                                      required
                                      v-bind:options="options2"
                                      hide-details
                                    />
                                  </v-col>
                                  <v-col
                                    cols="12"
                                  >
                                    <h4 class="mb-5 mt-0">
                                      <span style="font-weight: 500;" class="mr-3">คะแนนที่ได้รับ</span><span style="color: #1b437c;font-weight: 100;">*</span>
                                    </h4>
                                    <VuetifyMoney
                                      class="pa-0"
                                      v-model="formAdd.coin"
                                      label="คะแนนที่ได้รับ"
                                      placeholder="คะแนนที่ได้รับ"
                                      outlined
                                      dense
                                      :rules="[rules.moreThanZero]"
                                      required
                                      v-bind:options="options2"
                                      v-if="formAdd.type != 'LuckyDraw'"
                                    />
                                  </v-col>
                                  <v-col cols="12" class="px-0">
                                    <v-col class="pa-0">
                                      <!-- <v-row justify="center">
                                        <v-btn
                                          class="white--text"
                                          elevation="2"
                                          x-large
                                          block
                                          color="#173053"
                                          :disabled="!validAdd || formAdd.pictureUrlPreview === '' || !formAdd.pictureUrlPreview"
                                          :loading="loadingAdd"
                                          @click="addData()"
                                        >
                                          <v-icon left>mdi-checkbox-marked-circle</v-icon>
                                          บันทึก
                                        </v-btn>
                                      </v-row> -->
                                      <!-- อันแรก -->
                                      <div class="d-flex justify-space-between">
                                        <v-btn large outlined color="#1B437C" @click="clearDataAdd"><v-icon>mdi-chevron-left</v-icon>ย้อนกลับ</v-btn>
                                        <v-btn large outlined color="#1B437C" :disabled="!validAdd" @click="addData()">บันทึก</v-btn>
                                      </div>
                                    </v-col>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-card>
                          </v-form>
                        </div>
                      </v-col>
                    </v-row></v-container
                  >
                </v-card-text>
              </div>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog
            v-model="dialogEdit"
            persistent
            :max-width="resCol === '12' ? '' : '40%'"
            :fullscreen="resCol === '12' ? true : false"
          >
            <v-card>
              <v-container>
                <v-card-title>
                  <span class="headline">แก้ไขข้อมูล</span>
                </v-card-title>
                <v-card-text>
                  <v-form
                    ref="form_update"
                    v-model="validUpdate"
                    lazy-validation
                  >
                    <v-container>
                      <v-row justify="center">
                        <v-col cols="12" class="text-center">
                          <v-img
                            aspect-ratio="6"
                            contain
                            :src="formUpdate.pictureUrlPreview"
                          ></v-img>
                          <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                          <br />
                          <v-file-input
                            required
                            counter
                            show-size
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-icon="mdi-camera"
                            label="Image"
                            @change="selectImgUpdate"
                            v-model="filesUpdate"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                          <v-text-field
                            v-model="formUpdate.title"
                            label="ชื่อกิจกรรม"
                            placeholder="ชื่อกิจกรรม"
                            outlined
                            dense
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    elevation="2"
                    x-large
                    dark
                    color="#173053"
                    @click="(dialogEdit = false), getData();"
                  >
                    <v-icon left> mdi-cancel</v-icon>
                    ปิด
                  </v-btn>
                  <v-btn
                    elevation="2"
                    x-large
                    color="#173053"
                    dark
                    :disabled="!validUpdate"
                    :loading="loadingEdit"
                    @click="editData()"
                  >
                    <v-icon left>mdi-checkbox-marked-circle</v-icon>
                    บันทึก
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-card-title class="pa-2">
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formUpdate.title"
                        label="ชื่อกิจกรรม"
                        placeholder="ชื่อกิจกรรม"
                        outlined
                        dense
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
              <v-tabs grow background-color="white" v-model="tab">
                <v-tab>กิจกรรมทั้งหมด</v-tab>
                <v-tab v-if="$session.getAll().data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350'">เลือกแบบสอบถาม</v-tab>
              </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card elevation="0" v-if="dataReady">
                  <v-card-title>
                    <v-text-field
                      v-model="searchAll2"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      dense
                    ></v-text-field>
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="columns"
                      :items="dataItem"
                      :search="searchAll2"
                      :items-per-page="10"
                      dense
                    >
                      <template v-slot:[`item.quota`]="{ item }">
                        {{ formatNumber(item.quota) }}
                      </template>
                      <template v-slot:[`item.countUser`]="{ item }">
                        {{ formatNumber(item.countUser) }}
                      </template>
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ thaiFormattedDate(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.answerType`]="{ item }">
                        {{
                          item.answerType !== "คำตอบแบบข้อความ" &&
                          item.answerType !== "คำตอบแบบมากกว่า 1 ตัวเลือก" &&
                          item.answerType !== "คำตอบแบบ 1 ตัวเลือก"
                            ? "รับคะแนนฟรี"
                            : item.answerType
                        }}
                      </template>
                      <template v-slot:[`item.LAST_DATE`]="{ item }">
                        {{ thaiFormattedDate(item.LAST_DATE) }}
                      </template>
                      <template v-slot:[`item.status`]="{ item }">
                        <v-switch
                          inset
                          :label="item.status === true ? 'เปิด' : 'ปิด'"
                          v-model="item.status"
                          @change="test(item.status, item.activityId)"
                        ></v-switch>
                      </template>
                      <!-- <template
                        v-if="
                          $session.getAll().data.shopId ===
                          'U4e23f7bf31b362622ff7c5c06dfdf350'
                        "
                        v-slot:[`item.bvpStatusQuestionnaire`]="{ item }"
                      >
                        <p
                          class="mb-0"
                          v-if="item.bvpStatusQuestionnaire === true"
                          style="color: green"
                        >
                          <v-icon color="green">mdi-book-open-outline</v-icon>
                          แบบสอบถาม
                        </p>
                        <p v-else>ไม่ใช่แบบสอบถาม</p>
                      </template> -->
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="btn-color"
                              fab
                              dark
                              small
                              @click.stop="
                                (dialogEdit = true),
                                  getDataById(item),
                                  validate('UPDATE');
                              "
                            >
                              <v-icon dark> mdi-tools </v-icon>
                            </v-btn>
                          </template>
                          <span>แก้ไขข้อมูล</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              color="red"
                              dark
                              fab
                              small
                              @click.stop="
                                (dialogDelete = true), getDataById(item);
                              "
                            >
                              <v-icon> mdi-delete </v-icon>
                            </v-btn>
                          </template>
                          <span>ลบข้อมูล</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <div style="margin-top: 10px;">
                  <v-row>
                    <v-col cols="5" style="display: flex;justify-content: center;">
                      <v-card :style="!formUpdate2.title && !question ? 'width: 80%; min-height: 800px; max-height: 800px;' : 'width: 80%; min-height: 800px; overflow-y: auto; max-height: 800px;'">
                        <div>
                              <v-img
                                min-height="250"
                                :src="require('@/assets/review-01.jpg')"
                              >
                              <v-chip
                                class="ma-2"
                                color="rgb(235 246 130)"
                                label
                                text-color="black"
                              >
                                เลขที่ใบเสร็จ 123-456-7890
                              </v-chip>
                              </v-img>
                            <div style="position: relative;top: -40px;" class="mb-5">
                              <v-chip
                                class="ma-2"
                                color="rgb(235 246 130)"
                                label
                                text-color="black"
                              >
                                แบบประเมินความพึงพอใจ
                              </v-chip>
                              <div style="height: 100vh;background-color: white;">
                                <v-card elevation="0" class="text-center">
                                    <div v-if="question">
                                      <v-col v-for="(item, i) in JSON.parse(question.answerChoice)" :key="i">
                                        <div>
                                          <p style="font-weight: bold;margin-bottom: 6px;text-align: start;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ 'คำถามที่' }} {{i + 1}}</p>
                                          <p style="padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;text-align: start;"> - {{ item[0].split('/')[0] }} ?</p>
                                        </div>
                                        <div style="padding: 10px;background-color: rgb(0 0 0 / 8%);border-radius: 10px;">
                                          <div style="text-align: start;padding-left: 5px;font-weight: bold;margin-bottom: 5px;">* {{ 'เลือก 1 คำตอบ' }}</div>
                                          <div v-for="(item2, index) in item.filter((value, index) => { return index > 0})" :key="index">
                                            <v-card class="answer">
                                              <div class="answer2">
                                                <div>{{item2.split('/')[0]}}</div>
                                                <v-icon color="grey">mdi-checkbox-blank-circle-outline</v-icon>
                                              </div>
                                            </v-card>
                                          </div>
                                        </div>
                                      </v-col>
                                    </div>
                                    <v-card>
                                    <v-divider></v-divider>
                                    <v-card-text v-if="formUpdate2.title">
                                      <v-form >
                                      <v-container class="pl-4 pr-4 pt-5">
                                        <v-row justify="center">
                                          <v-col class="text-center">
                                            <b style="font-size: 20px;">{{ 'กรอกข้อมูล' }}</b>
                                          </v-col>
                                        </v-row>
                                        <v-row v-if="formUpdate2.field1Title">
                                          <v-col cols="12">
                                            <div>
                                              <p style="text-align: start;font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ 'คำถามที่' }} 1</p>
                                              <p style="text-align: start;padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ formUpdate2.field1Title[0] }}</p>
                                            </div>
                                            <v-textarea
                                              v-if="formUpdate2.field1Type !== 'dateTime'"
                                              outlined
                                              dense
                                              :rules="
                                                formUpdate2.field1Type === 'citizenNumber'
                                                  ? [formUpdate2.key1.email]
                                                  : formUpdate2.field1Type === 'email'
                                                  ? [formUpdate2.key1.email]
                                                  : [formUpdate2.key1.required]
                                              "
                                              required
                                              v-model="formUpdateItem.field1Value"
                                            ></v-textarea>
                                            <v-menu
                                              ref="menu1"
                                              v-model="menu1"
                                              :close-on-content-click="false"
                                              transition="scale-transition"
                                              offset-y
                                              min-width="290px"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                  v-model="formUpdateItem.field1Value"
                                                  :label="formUpdate2.field1Title[0]"
                                                  readonly
                                                  v-if="formUpdate2.field1Type == 'dateTime'"
                                                  dense
                                                  :rules="[formUpdate2.key1.required]"
                                                  v-bind="attrs"
                                                  v-on="on"
                                                ></v-text-field>
                                              </template>
                                              <v-date-picker
                                                ref="picker1"
                                                v-model="formUpdateItem.field1Value"
                                                :max="new Date().toISOString().substr(0, 10)"
                                                min="1950-01-01"
                                              ></v-date-picker>
                                            </v-menu>
                                          </v-col>
                                        </v-row>
                                        <v-row v-if="formUpdate2.field2Title">
                                          <v-col cols="12">
                                            <div>
                                              <p style="text-align: start;font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ 'คำถามที่' }} 2</p>
                                              <p style="text-align: start;padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ formUpdate2.field2Title[0] }}</p>
                                            </div>
                                            <v-textarea
                                              v-if="formUpdate2.field2Type !== 'dateTime'"
                                              outlined
                                              dense
                                              :rules="
                                                formUpdate2.field1Type === 'citizenNumber'
                                                  ? [formUpdate2.key1.email]
                                                  : formUpdate2.field1Type === 'email'
                                                  ? [formUpdate2.key1.email]
                                                  : [formUpdate2.key1.required]
                                              "
                                              required
                                              v-model="formUpdateItem.field2Value"
                                            ></v-textarea>
                                            <v-menu
                                              ref="menu2"
                                              v-model="menu2"
                                              :close-on-content-click="false"
                                              transition="scale-transition"
                                              offset-y
                                              min-width="290px"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                  v-model="formUpdateItem.field2Value"
                                                  :label="formUpdate2.field2Title[0]"
                                                  readonly
                                                  :rules="[v => !!v || 'This field is required']"
                                                  v-if="formUpdate2.field2Type == 'dateTime'"
                                                  dense
                                                  v-bind="attrs"
                                                  v-on="on"
                                                ></v-text-field>
                                              </template>
                                              <v-date-picker
                                                ref="picker1"
                                                v-model="formUpdateItem.field2Value"
                                                :max="new Date().toISOString().substr(0, 10)"
                                                min="1950-01-01"
                                              ></v-date-picker>
                                            </v-menu>
                                          </v-col>
                                        </v-row>
                                        <v-row v-if="formUpdate2.field3Title">
                                          <v-col cols="12">
                                            <div>
                                              <p style="text-align: start;font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ 'คำถามที่' }} 3</p>
                                              <p style="text-align: start;;padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ formUpdate2.field3Title[0] }}</p>
                                            </div>
                                            <v-text-field
                                              v-if="formUpdate2.field3Type !== 'dateTime'"
                                              outlined
                                              dense
                                              v-model="formUpdateItem.field3Value"
                                            ></v-text-field>
                                            <v-menu
                                              ref="menu3"
                                              v-model="menu3"
                                              :close-on-content-click="false"
                                              transition="scale-transition"
                                              offset-y
                                              min-width="290px"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                  v-model="formUpdateItem.field3Value"
                                                  :label="formUpdate2.field3Title[0]"
                                                  readonly
                                                  :rules="[formUpdate2.key3.required]"
                                                  v-if="formUpdate2.field3Type == 'dateTime'"
                                                  dense
                                                  v-bind="attrs"
                                                  v-on="on"
                                                ></v-text-field>
                                              </template>
                                              <v-date-picker
                                                ref="picker3"
                                                v-model="formUpdateItem.field3Value"
                                                :max="new Date().toISOString().substr(0, 10)"
                                                min="1950-01-01"
                                              ></v-date-picker>
                                            </v-menu>
                                          </v-col>
                                        </v-row>
                                        <v-row v-if="formUpdate.field4Title">
                                          <v-col cols="12">
                                            <div>
                                              <p style="text-align: start;font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ 'คำถามที่' }} 4</p>
                                              <p style="text-align: start;;padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ formUpdate2.field4Title[0] }}</p>
                                            </div>
                                            <v-text-field
                                              v-if="formUpdate2.field4Type !== 'dateTime'"
                                              outlined
                                              dense
                                            ></v-text-field>
                                            <v-menu
                                              ref="menu4"
                                              v-model="menu4"
                                              :close-on-content-click="false"
                                              transition="scale-transition"
                                              offset-y
                                              min-width="290px"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                  :label="formUpdate2.field4Title[0]"
                                                  prepend-icon="event"
                                                  v-if="formUpdate2.field4Type == 'dateTime'"
                                                  dense
                                                  v-bind="attrs"
                                                  v-on="on"
                                                ></v-text-field>
                                              </template>
                                              <v-date-picker
                                                ref="picker4"
                                                v-model="formUpdateItem.field4Value"
                                                :max="new Date().toISOString().substr(0, 10)"
                                                min="1950-01-01"
                                              ></v-date-picker>
                                            </v-menu>
                                          </v-col>
                                        </v-row>
                                      </v-container>
                                      </v-form>
                                    </v-card-text>
                                    <v-divider style="margin: 0;"></v-divider>
                                    <v-card-actions v-if="formUpdate2.title || question" class="text-center" style="justify-content: space-evenly;padding-bottom:20px">
                                          <v-btn
                                            class="white--text"
                                            color="#69dd61"
                                            width="auto"
                                            block
                                            style="border-radius: 15px;font-size: 16px;"
                                          >
                                          🎁  รับคะแนน
                                          </v-btn>
                                    </v-card-actions>
                                    </v-card>
                                </v-card>
                              </div>
                            </div>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="7">
                      <p>แบบสอบถามประเภทตัวเลือก</p>
                      <div  class="mb-7" style="padding: 15px;border: solid #d6d6d6 1.5px;border-radius: 15px;">
                        <v-data-table
                          :headers="columns2"
                          :items="
                            dataItem.filter(
                              (item) =>
                                item.answerType ===
                                  'คำตอบแบบมากกว่า 1 ตัวเลือก' ||
                                item.answerType === 'คำตอบแบบ 1 ตัวเลือก',
                            )
                          "
                          :search="searchAll2"
                          :items-per-page="5"
                        >
                        <template
                            v-if="
                              $session.getAll().data.shopId ===
                              'U4e23f7bf31b362622ff7c5c06dfdf350'
                            "
                            v-slot:[`item.bvpStatusQuestionnaire`]="{ item }"
                          >
                            <v-switch
                              v-model="item.bvpStatusQuestionnaire"
                              inset
                              @change="
                                changQuestion(
                                  item.bvpStatusQuestionnaire,
                                  item.activityId,
                                  item.answerType,
                                )
                              "
                            >
                            </v-switch>
                          </template>
                        </v-data-table>
                      </div>
                      <p>แบบสอบถามประเภทตัวเลือก</p>
                      <div class="mb-7" style="padding: 15px;border: solid #d6d6d6 1.5px;border-radius: 15px;">
                        <v-data-table
                          :headers="columns2"
                          :items="
                            dataItem.filter(
                              (item) => item.answerType === 'คำตอบแบบข้อความ',
                            )
                          "
                          :search="searchAll2"
                          :items-per-page="10"
                        >
                          <template
                            v-if="
                              $session.getAll().data.shopId ===
                              'U4e23f7bf31b362622ff7c5c06dfdf350'
                            "
                            v-slot:[`item.bvpStatusQuestionnaire`]="{ item }"
                          >
                            <v-switch
                              v-model="item.bvpStatusQuestionnaire"
                              inset
                              @change="
                                changQuestion(
                                  item.bvpStatusQuestionnaire,
                                  item.activityId,
                                  item.answerType,
                                )
                              "
                            >
                            </v-switch>
                          </template>
                        </v-data-table>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col cols="5">
                    </v-col>
                    <v-col cols="7" >
                      <p>แบบสอบถามประเภทตัวเลือก</p>
                      <v-card>
                        <v-data-table
                          :headers="columns2"
                          :items="
                            dataItem.filter(
                              (item) =>
                                item.answerType ===
                                  'คำตอบแบบมากกว่า 1 ตัวเลือก' ||
                                item.answerType === 'คำตอบแบบ 1 ตัวเลือก',
                            )
                          "
                          :search="searchAll2"
                          :items-per-page="10"
                          dense
                        />
                      </v-card>
                      <p>แบบสอบถามประเภทข้อความ</p>
                      <v-card>
                        <v-data-table
                          :headers="columns2"
                          :items="
                            dataItem.filter(
                              (item) => item.answerType === 'คำตอบแบบข้อความ',
                            )
                          "
                          :search="searchAll2"
                          :items-per-page="10"
                          dense
                        />
                      </v-card>
                    </v-col>
                  </v-row> -->
                </div>
              </v-tab-item>
            </v-tabs-items>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
</template>
<script>
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  data () {
    return {
      PK: '',
      path: '/activity/', // Path Model
      returnLink: '/Tool/Activity',
      // Menu Config
      countQuestion: 1,
      tab: 0,
      typeExpire: 'มีวันสิ้นสุดกิจกรรม',
      inline: 'จำกัดจำนวนคนเข้าร่วม',
      secoundStep: null,
      validAdd2: false,
      validAdd3: false,
      thirdStep: false,
      itemsTypeExpire: ['มีวันสิ้นสุดกิจกรรม', 'ไม่มีวันสิ้นสุดกิจกรรม'],
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Activity',
          disabled: false,
          href: '/Tool/Activity'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      selectTypeField: [
        { text: 'Text', value: 'text' },
        { text: 'Number', value: 'number' },
        { text: 'Datetime', value: 'dateTime' },
        { text: 'Email', value: 'email' },
        { text: 'CitizenNumber', value: 'citizenNumber' }
      ],
      selectType: [
        {
          text: 'ตอบคำถามรับคะแนน',
          value: 'กรอกข้อมูล',
          icon: 'mdi-message-question',
          color: 'grey'
        },
        {
          text: 'รับคะแนน ฟรี!',
          value: 'FreeCoin',
          icon: 'mdi-alpha-c-circle-outline',
          color: 'grey'
        }
        // {
        //   text: 'Lucky Draw',
        //   value: 'LuckyDraw',
        //   icon: 'mdi-dice-multiple',
        //   color: 'grey'
        // }
      ],
      selectRepeat: [
        { text: 'ครั้งเดียว', value: 'OneTime' },
        { text: 'ทุกวัน', value: 'Daily' },
        { text: 'ทุกสัปดาห์', value: 'Weekly' },
        { text: 'ทุกเดือน', value: 'Monthly' }
      ],
      dialogCreateQuestion: false,
      camera: 'auto',
      result: null,
      activityType: 'ตอบคำถามรับคะแนน',
      showScanConfirmation: false,
      // End Menu Config
      dataReady: true,
      dataShowQR: false,
      number: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      dialogRedeem: false,
      size: 150, // QR Code
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      dialogViewLot: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogSend: false,
      dialogAdd: false,
      dialogAddLot: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogView: false,
      dialogViewAdd: false,
      dialogDoc: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0, 1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      filesAdd: null,
      numChoice: 2,
      filesUpdate: null,
      formAdd: {
        activityId: '',
        title: '',
        titleEng: '',
        type: null,
        answerType: '',
        repeats: '',
        startDate: '',
        endDate: '',
        quota: '',
        coin: 0,
        answerChoice: [['']],
        field1Title: [],
        field1Type: '',
        field2Title: [''],
        field2Type: '',
        field3Title: [''],
        field3Type: '',
        field4Title: [''],
        field4Type: '',
        Primary_field: '',
        chkbox1: false,
        chkbox2: false,
        chkbox3: false,
        chkbox4: false,
        shopId: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: ''
      },
      formUpdate: {
        activityId: '',
        title: '',
        type: '',
        repeats: '',
        startDate: '',
        endDate: '',
        quota: '',
        coin: 0,
        field1Title: '',
        field1Type: '',
        field2Title: '',
        field2Type: '',
        field3Title: '',
        field3Type: '',
        field4Title: '',
        field4Type: '',
        Primary_field: '',
        shopId: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: ''
      },
      formUpdate2: {
        activityId: '',
        field1Title: '',
        field1Type: '',
        key1: {},
        chkKey: '',
        field2Title: '',
        field2Type: '',
        key2: {},
        field3Title: '',
        field3Type: '',
        key3: {},
        field4Title: '',
        field4Type: '',
        key4: {},
        primary: '',
        coin: '',
        pictureUrl: '',
        title: ''
      },
      menu1: false,
      formUpdateItem: {
        title: '',
        pictureUrl: ''
      },
      answerChoiceEng: [['']],
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length <= 10 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอกข้อมูล.',
        moreThanZero: value => parseFloat(value) > 0 || 'ต้องมากกว่า 0',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns2: [
        { text: 'หัวข้อ', value: 'title' },
        { text: 'คำถามแบบสอบถาม', value: 'bvpStatusQuestionnaire' }
      ],
      columns: [
        { text: 'หัวข้อ', value: 'title' },
        { text: 'ประเภท', value: 'answerType' },
        { text: 'ทำซ้ำ', value: 'repeats' },
        { text: 'รวม', value: 'quota' },
        { text: 'ใช้แล้ว', value: 'countUse' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'สถานะ', value: 'status' },
        // { text: 'คำถามแบบสอบถาม', value: 'bvpStatusQuestionnaire' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      ProductExchangeRate: [],
      dataItem: [],
      dataItemViewLot: [],
      answer1Choice: null,
      answerTypeList: [
        'คำตอบแบบข้อความ',
        'คำตอบแบบ 1 ตัวเลือก',
        'คำตอบแบบมากกว่า 1 ตัวเลือก'
      ],
      Updatedata: null,
      dataBranch: [],
      validAdd: false,
      validAddLot: true,
      validUpdate: true,
      dailogViewRedeem: false,
      statusViewRedeem: false,
      loadingInsert: false,
      question: null,
      data: null,
      data2: null,
      // End Data Table Config
      //   loading
      loadingAdd: false,
      loadingEdit: false,
      idLastQuestion: null,
      idLastQuestion2: null,
      required: [(v) => !!v || 'กรุณากรอกข้อมูล']
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getDataBranch()
    // this.getProductExchangeRate()
    try {
      this.dataReady = false
      // this.flex2html('flex1', {'type': 'flex', 'altText': 'Flex Message', 'contents': {'type': 'bubble', 'hero': {'type': 'image', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/01_1_cafe.png', 'size': 'full', 'aspectRatio': '20:13', 'aspectMode': 'cover', 'action': {'type': 'uri', 'uri': 'http://linecorp.com/'}}, 'body': {'type': 'box', 'layout': 'vertical', 'contents': [{'type': 'text', 'text': 'Brown Cafe', 'weight': 'bold', 'size': 'xl'}, {'type': 'box', 'layout': 'baseline', 'margin': 'md', 'contents': [{'type': 'icon', 'size': 'sm', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'}, {'type': 'icon', 'size': 'sm', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'}, {'type': 'icon', 'size': 'sm', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'}, {'type': 'icon', 'size': 'sm', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'}, {'type': 'icon', 'size': 'sm', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gray_star_28.png'}, {'type': 'text', 'text': '4.0', 'size': 'sm', 'color': '#999999', 'margin': 'md', 'flex': 0}]}, {'type': 'box', 'layout': 'vertical', 'margin': 'lg', 'spacing': 'sm', 'contents': [{'type': 'box', 'layout': 'baseline', 'spacing': 'sm', 'contents': [{'type': 'text', 'text': 'Place', 'color': '#aaaaaa', 'size': 'sm', 'flex': 1}, {'type': 'text', 'text': 'Miraina Tower, 4-1-6 Shinjuku, Tokyo', 'wrap': true, 'color': '#666666', 'size': 'sm', 'flex': 5}]}, {'type': 'box', 'layout': 'baseline', 'spacing': 'sm', 'contents': [{'type': 'text', 'text': 'Time', 'color': '#aaaaaa', 'size': 'sm', 'flex': 1}, {'type': 'text', 'text': '10:00 - 23:00', 'wrap': true, 'color': '#666666', 'size': 'sm', 'flex': 5}]}]}]}, 'footer': {'type': 'box', 'layout': 'vertical', 'spacing': 'sm', 'contents': [{'type': 'button', 'style': 'link', 'height': 'sm', 'action': {'type': 'uri', 'label': 'CALL', 'uri': 'https://linecorp.com'}}, {'type': 'button', 'style': 'link', 'height': 'sm', 'action': {'type': 'uri', 'label': 'WEBSITE', 'uri': 'https://linecorp.com'}}, {'type': 'spacer', 'size': 'sm'}], 'flex': 0}}})
      // Get Data
      if (
        this.$session.getAll().data.shopId !==
        'U4e23f7bf31b362622ff7c5c06dfdf350'
      ) {
        this.columns = this.columns.filter(
          (column) => column.text !== 'คำถามแบบสอบถาม'
        )
      } else {
        this.showQuetions()
      }
      await this.getData()
      console.log('this.dataItem222', this.dataItem)
    } catch (error) {
      console.log('error', error)
    }
    // this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId + '&status=waiting')
    // console.log('xxxx', this.dataItem)
    console.log('fff', this.formAdd)
  },
  methods: {
    // checkSecoundStep (item) {
    //   if (item === 'กรอกข้อมูล') {

    //   } else {

    //   }
    // },
    async showQuetions () {
      try {
        this.data2 = null
        this.data = null
        this.question = null
        const result = await axios.get(this.DNS_IP + `/activity/get/bvp`)
        console.log('bvp', result.data)
        if (Array.isArray(result.data)) {
          this.data = result.data.filter(item => item.answerType !== 'คำตอบแบบข้อความ')
          this.data2 = result.data.filter(item => item.answerType === 'คำตอบแบบข้อความ')
          console.log('this.data[0]', Array.isArray(this.data))
          console.log('this.data[0]', Array.isArray(this.data2))
          if (Array.isArray(this.data) && this.data.length > 0) {
            await this.convertActivityChoice(this.data[0])
          } else {
            this.question = null
          }
          if (Array.isArray(this.data2) && this.data2.length > 0) {
            console.log('เข้าครับ')
            await this.convertActivityText(this.data2[0])
          } else {
            console.log('ไม่เข้าเข้าครับ')
            this.formUpdate2 = {
              activityId: '',
              field1Title: '',
              field1Type: '',
              key1: {},
              chkKey: '',
              field2Title: '',
              field2Type: '',
              key2: {},
              field3Title: '',
              field3Type: '',
              key3: {},
              field4Title: '',
              field4Type: '',
              key4: {},
              primary: '',
              coin: '',
              pictureUrl: '',
              title: ''
            }
          }
        } else {
          this.question = null
          this.formUpdate2 = {
            activityId: '',
            field1Title: '',
            field1Type: '',
            key1: {},
            chkKey: '',
            field2Title: '',
            field2Type: '',
            key2: {},
            field3Title: '',
            field3Type: '',
            key3: {},
            field4Title: '',
            field4Type: '',
            key4: {},
            primary: '',
            coin: '',
            pictureUrl: '',
            title: ''
          }
        }
        await this.$forceUpdate()
      } catch (error) {
      }
    },
    async convertActivityText (item) {
      console.log('itemitemitemitem', item)
      try {
        if (item) {
          console.log('item.field1Title', item.field1Title)

          this.formUpdate2.field1Title = item.field1Title ? JSON.parse(item.field1Title) : item.field1Title
          this.formUpdate2.field1Type = item.field1Type
          this.formUpdate2.field2Title = item.field2Title ? JSON.parse(item.field2Title) : item.field2Title
          this.formUpdate2.field2Type = item.field2Type
          this.formUpdate2.field3Title = item.field3Title ? JSON.parse(item.field3Title) : item.field3Title
          this.formUpdate2.field3Type = item.field3Type
          this.formUpdate2.field4Title = item.field4Title ? JSON.parse(item.field4Title) : item.field4Title
          this.formUpdate2.field4Type = item.field4Type
          this.formUpdate2.title = item.title
        }
      } catch (error) {
      }
      console.log('itemitemitemitem', this.formUpdate2)
    },
    async convertActivityChoice (item) {
      try {
        if (item.type === 'กรอกข้อมูล' && item.answerType === 'คำตอบแบบ 1 ตัวเลือก') {
          this.answer1Choice = []
          this.question = item
          let arrayForquestion = JSON.parse(item.answerChoice)
          arrayForquestion.forEach(element => this.answer1Choice.push([element[0]]))
        } else if (item.type === 'กรอกข้อมูล' && item.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก') {
          this.answer1Choice = []
          this.question = item
          let arrayForquestion = JSON.parse(item.answerChoice)
          arrayForquestion.forEach(element => this.answer1Choice.push([element[0]]))
        }
        console.log('question', this.question)
      } catch (error) {
        console.log(error)
      }
    },
    deleteQuetiion (i) {
      this.formAdd.answerChoice.splice(i, 1)
      this.answerChoiceEng.splice(i, 1)
    },
    addChoice2 (count, i, item) {
      try {
        this.formAdd.answerChoice[i] = [this.formAdd.answerChoice[i][0]]
        this.answerChoiceEng[i] = [this.answerChoiceEng[i][0]]
        for (let a = 0; a < count; a++) {
          this.formAdd.answerChoice[i].push('')
          this.answerChoiceEng[i].push('')
        }
        this.$forceUpdate()
        // console.log('item', this.formAdd.answerChoice)
        // console.log('item', this.answerChoiceEng[i])
      } catch (error) {
        console.log('error', error)
      }
    },
    async validateFromAdd3 () {
      try {
        if (this.$refs.form_add3.validate()) {
          if (this.formAdd.type === 'กรอกข้อมูล') {
            this.formAdd.repeats = 'OneTime'
          } else {
            this.formAdd.answerChoice = null
            this.formAdd.answerType = null
            console.log('ไม่ใข่รอกข้อมูล', this.formAdd)
          }
          this.callApiAddData()
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    validateFrom () {
      if (this.$refs.form_add2.validate()) {
        this.thirdStep = true
        console.log('2222', this.formAdd)
      }
    },
    async getData () {
      try {
        await axios
          .get(
            this.DNS_IP +
              '/activity/get/filter?shopId=' +
              this.$session.getAll().data.shopId
          )
          .then((response) => {
            this.dataItem = response.data
            if (Array.isArray(this.dataItem)) {
              this.dataItem.map((item) => {
                if (item.status === 'True') {
                  item.status = true
                } else if (item.status === 'False') {
                  item.status = false
                } else {
                  item.status = item.status.toLowerCase() === 'true'
                }
                if (
                  this.$session.getAll().data.shopId ===
                  'U4e23f7bf31b362622ff7c5c06dfdf350'
                ) {
                  if (item.bvpStatusQuestionnaire) {
                    if (item.bvpStatusQuestionnaire === 'True') {
                      item.bvpStatusQuestionnaire = true
                    } else {
                      item.bvpStatusQuestionnaire = false
                    }
                  } else {
                    item.bvpStatusQuestionnaire = false
                  }
                }
              })
              this.idLastQuestion = this.dataItem
                .filter((item) => item.answerType !== 'คำตอบแบบข้อความ')
                .filter((item) => item.bvpStatusQuestionnaire === true)
              this.idLastQuestion2 = this.dataItem
                .filter((item) => item.answerType === 'คำตอบแบบข้อความ')
                .filter((item) => item.bvpStatusQuestionnaire === true)
              this.dataReady = true
              console.log('dataMember', this.dataItem)
            } else {
              this.dataItem = []
              this.dataReady = true
            }
          })
      } catch (error) {
        console.log('activity error', error)
      }
    },
    async test (a, id) {
      console.log('dddddd')
      try {
        this.Updatedata = { status: a }
        await axios
          .post(this.DNS_IP + this.path + 'edit/' + id, this.Updatedata)
          .then(async (response) => {
            // Debug response
            console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

            this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
            // Close Dialog

            // Load Data
            // await this.reloadData()
            await this.getData()
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.dataReady = true
            console.log('error function editDataGlobal : ', error)
            this.$router.push(
              '/system/Errorpage?returnLink=' + this.returnLink
            )
          })
      } catch (error) {
        alert(error)
      }
    },
    async changQuestion (a, id, answerType) {
      try {
        console.log(this.idLastQuestion)
        if (answerType !== 'คำตอบแบบข้อความ') {
          if (this.idLastQuestion.length === 0) {
            this.Updatedata = { bvpStatusQuestionnaire: a }
            await axios
              .post(this.DNS_IP + this.path + 'edit/' + id, this.Updatedata)
              .then(async (response) => {
                // Debug response
                console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

                this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                await this.getData()
              })
              .catch((error) => {
                this.dataReady = true
                console.log('error function editDataGlobal : ', error)
                this.$router.push(
                  '/system/Errorpage?returnLink=' + this.returnLink
                )
              })
          } else {
            if (id === this.idLastQuestion[0].activityId) {
              this.Updatedata = { bvpStatusQuestionnaire: a }
              await axios
                .post(this.DNS_IP + this.path + 'edit/' + id, this.Updatedata)
                .then(async (response) => {
                  // Debug response
                  console.log(
                    'editDataGlobal DNS_IP + PATH + "edit"',
                    response
                  )

                  this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                  await this.getData()
                })
                .catch((error) => {
                  this.dataReady = true
                  console.log('error function editDataGlobal : ', error)
                  this.$router.push(
                    '/system/Errorpage?returnLink=' + this.returnLink
                  )
                })
            } else {
              this.Updatedata1 = { bvpStatusQuestionnaire: a }
              await axios
                .post(this.DNS_IP + this.path + 'edit/' + id, this.Updatedata1)
                .then(async (response) => {
                  // Debug response
                  console.log(
                    'editDataGlobal DNS_IP + PATH + "edit"',
                    response
                  )
                })
                .catch((error) => {
                  this.dataReady = true
                  console.log('error function editDataGlobal : ', error)
                  this.$router.push(
                    '/system/Errorpage?returnLink=' + this.returnLink
                  )
                })
              this.Updatedata2 = { bvpStatusQuestionnaire: false }
              await axios
                .post(
                  this.DNS_IP +
                    this.path +
                    'edit/' +
                    this.idLastQuestion[0].activityId,
                  this.Updatedata2
                )
                .then(async (response) => {
                  // Debug response
                  console.log(
                    'editDataGlobal DNS_IP + PATH + "edit"',
                    response
                  )

                  this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                  await this.getData()
                })
                .catch((error) => {
                  this.dataReady = true
                  console.log('error function editDataGlobal : ', error)
                  this.$router.push(
                    '/system/Errorpage?returnLink=' + this.returnLink
                  )
                })
            }
          }
        } else {
          console.log('ffff', this.idLastQuestion2)
          if (this.idLastQuestion2.length === 0) {
            this.Updatedata = { bvpStatusQuestionnaire: a }
            await axios
              .post(this.DNS_IP + this.path + 'edit/' + id, this.Updatedata)
              .then(async (response) => {
                // Debug response
                console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

                this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                await this.getData()
              })
              .catch((error) => {
                this.dataReady = true
                console.log('error function editDataGlobal : ', error)
                this.$router.push(
                  '/system/Errorpage?returnLink=' + this.returnLink
                )
              })
          } else {
            if (id === this.idLastQuestion2[0].activityId) {
              this.Updatedata = { bvpStatusQuestionnaire: a }
              await axios
                .post(this.DNS_IP + this.path + 'edit/' + id, this.Updatedata)
                .then(async (response) => {
                  // Debug response
                  console.log(
                    'editDataGlobal DNS_IP + PATH + "edit"',
                    response
                  )

                  this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                  await this.getData()
                })
                .catch((error) => {
                  this.dataReady = true
                  console.log('error function editDataGlobal : ', error)
                  this.$router.push(
                    '/system/Errorpage?returnLink=' + this.returnLink
                  )
                })
            } else {
              this.Updatedata1 = { bvpStatusQuestionnaire: a }
              await axios
                .post(this.DNS_IP + this.path + 'edit/' + id, this.Updatedata1)
                .then(async (response) => {
                  // Debug response
                  console.log(
                    'editDataGlobal DNS_IP + PATH + "edit"',
                    response
                  )
                })
                .catch((error) => {
                  this.dataReady = true
                  console.log('error function editDataGlobal : ', error)
                  this.$router.push(
                    '/system/Errorpage?returnLink=' + this.returnLink
                  )
                })
              this.Updatedata2 = { bvpStatusQuestionnaire: false }
              await axios
                .post(
                  this.DNS_IP +
                    this.path +
                    'edit/' +
                    this.idLastQuestion2[0].activityId,
                  this.Updatedata2
                )
                .then(async (response) => {
                  // Debug response
                  console.log(
                    'editDataGlobal DNS_IP + PATH + "edit"',
                    response
                  )

                  this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                  await this.getData()
                })
                .catch((error) => {
                  this.dataReady = true
                  console.log('error function editDataGlobal : ', error)
                  this.$router.push(
                    '/system/Errorpage?returnLink=' + this.returnLink
                  )
                })
            }
          }
        }
        await this.showQuetions()
        await this.$forceUpdate()
      } catch (error) {
        alert(error)
      }
    },
    handleQuestionChange (item) {
      // This method is called when the v-text-field value changes
      item = item + ''
      console.log('Input value changed:', item)
    },
    toggleMarker (item2, item) {
      this.formAdd.answerChoice.map((a) => {
        if (a === item) {
          a.splice(item2, 1)
        }
      })
    },
    addChoice (item, i) {
      item.push('')
      this.answerChoiceEng[i].push('')
      console.log(item)
    },
    addQuestion () {
      this.formAdd.answerChoice.push([''])
      this.answerChoiceEng.push([''])
      console.log('ddddd', this.formAdd.answerChoice)
    },
    chooseImage () {
      this.$refs.fileInput.click()
    },
    onSelectFile () {
      const input = this.$refs.fileInput
      this.filesAdd = input.files
      if (this.filesAdd) {
        console.log('เข้า')
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd[0])
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      this.$forceUpdate()
      console.log('kkkk', this.formAdd.pictureUrlPreview)
    },
    changColor (item) {
      console.log(item)
      this.selectType.map((a) => {
        a.text === item.text ? (a.color = '#1b437c') : (a.color = 'grey')
      })
      console.log('this.selectType', this.selectType)
    },
    sendData (dt) {
      this.$swal({
        title: 'ต้องการ แจ้งเดือน ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        console.log(dt)
        var data = {
          shopId: dt.shopId,
          module: 'activity',
          referId: dt.activityId,
          pictureUrl: dt.pictureUrl,
          message: dt.title,
          CREATE_USER: this.session.data.userName,
          LAST_USER: this.session.data.userName
        }
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/broadcast/add",
            data
          )
          .then(async (response) => {
            console.log('addDataGlobal DNS_IP + PATH + "add"', response)

            this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log(error)
            this.$router.push(
              '/system/Errorpage?returnLink=' + this.returnLink
            )
            this.dataReady = true
          })
      })
    },
    selectImgUpdate (event) {
      if (this.filesUpdate) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    async selectImg (event) {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = await URL.createObjectURL(
          this.filesAdd
        )
        this.formAdd.title = 'd'
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    chkTypeVideo () {
      if (this.formAdd.type === 'video') {
        this.formAdd.repeats = 'OneTime'
      }
    },
    chkTypeCoin () {
      if (this.formAdd.type === 'LuckyDraw') {
        this.formAdd.coin = 0
      }
    },
    chkTypeFiled () {
      if (this.formAdd.type !== 'กรอกข้อมูล') {
        // this.formAdd.coin = 0
        this.formAdd.field1Title = ''
        this.formAdd.field1Type = ''
        this.formAdd.field2Title = ''
        this.formAdd.field2Type = ''
        this.formAdd.field3Title = ''
        this.formAdd.field3Type = ''
        this.formAdd.field4Title = ''
        this.formAdd.field4Type = ''
        this.formAdd.Primary_field = ''
      }
    },
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchName
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
          console.log('getDataCompany : ', this.dataBranch)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          console.log(error)
        })
    },
    // validate (Action) {
    //   switch (Action) {
    //     case 'ADD':
    //       this.$nextTick(() => {
    //         let self = this
    //         self.$refs.form_add.validate()
    //       })
    //       break
    //     case 'ADDLOT':
    //       this.$nextTick(() => {
    //         let self = this
    //         self.$refs.form_addLot.validate()
    //       })
    //       break
    //     case 'UPDATE':
    //       this.$nextTick(() => {
    //         let self = this
    //         self.$refs.form_update.validate()
    //       })
    //       break

    //     default:
    //       break
    //   }
    // },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?id=' +
        this.searchAll +
        '&productExchangeRateId=' +
        this.searchAll +
        '&amount=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item) {
      console.log(item)
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'activityId',
        item.activityId,
        this.returnLink
      )
      this.formUpdate.pictureUrlPreview = this.formUpdate.pictureUrl
    },
    async addData () {
      if (this.$refs.form_add.validate()) {
        // JSON.stringify(this.formAdd.answerChoice).trim().replace(/(\r\n|\n|\r)/gm, '').replace(/'/g, "\\'").replace(/%/g, '%%')

        if (this.formAdd.type === 'กรอกข้อมูล') {
          this.formAdd.repeats = 'OneTime'
        } else {
          this.formAdd.answerChoice = null
          this.formAdd.answerType = null
          console.log('ไม่ใข่รอกข้อมูล', this.formAdd)
        }
        console.log('ผ่าน')
        await this.callApiAddData()
      }
    },
    async callApiAddData () {
      console.log('this.formAdd', this.formAdd)
      // this.dataReady = false
      // this.dataShowQR = false

      console.log('api', this.formAdd)
      console.log('this.formAdd.answerChoice', this.formAdd)
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingInsert = true
          this.loadingAdd = true
          const today = new Date()
          // console.log(today)
          this.chkTypeVideo()
          const date =
            today.getFullYear() +
            '' +
            (today.getMonth() + 1) +
            '' +
            today.getDate()
          const time =
            today.getHours() +
            '' +
            today.getMinutes() +
            '' +
            today.getSeconds()
          const activityId = 'ACT_' + date + '' + time
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          this.formAdd.activityId = activityId
          // this.formAdd.token = tokenKey
          // this.formAdd.statusLot = 'no'
          this.formAdd.shopId = this.$session.getAll().data.shopId
          // const _this = this
          // let params = new FormData()
          // if (this.filesAdd) {
          //   params.append('file', this.filesAdd[0])

          //   await axios
          //     .post(this.DNS_IP + `/file/upload/activity`, params)
          //     .then(function (response) {
          //       _this.formAdd.pictureUrl = response.data
          //       console.log('url Pic', response.data)
          //     })
          //   delete this.formAdd['pictureUrlPreview']
          // }
          delete this.formAdd['pictureUrlPreview']
          console.log('stringify1', this.formAdd.answerChoice)
          if (
            this.formAdd.answerType === 'คำตอบแบบ 1 ตัวเลือก' ||
            this.formAdd.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก'
          ) {
            this.formAdd.answerChoice.map((item, index) => {
              item.map((item2, index2) => {
                item[index2] =
                  item[index2] + '/' + this.answerChoiceEng[index][index2]
              })
            })
            this.formAdd.answerChoice = JSON.stringify(
              this.formAdd.answerChoice
            )
              .trim()
              .replace(/(\r\n|\n|\r)/gm, '')
              .replace(/"/g, '\\"')
              .replace(/'/g, "\\'")
              .replace(/%/g, '%%')
            console.log('answerChoice', this.formAdd.answerChoice)
            // console.log('answerChoiceEng', this.answerChoiceEng)
          } else {
            // this.formAdd.field1Title = this.formAdd.field1Title.length === 1 ?  :
            // แบบข้อความ JSON.stringify
            console.log('this.formAdd.field1Title', this.formAdd.field1Title)
            this.formAdd.field1Title =
              this.formAdd.field1Title.length > 0
                ? JSON.stringify(this.formAdd.field1Title)
                  .trim()
                  .replace(/(\r\n|\n|\r)/gm, '')
                  .replace(/'/g, "\\'")
                  .replace(/"/g, '\\"')
                  .replace(/%/g, '%%')
                : ''

            this.formAdd.field2Title =
              this.formAdd.field2Title.length > 0
                ? JSON.stringify(this.formAdd.field2Title)
                  .trim()
                  .replace(/(\r\n|\n|\r)/gm, '')
                  .replace(/'/g, "\\'")
                  .replace(/"/g, '\\"')
                  .replace(/%/g, '%%')
                : ''

            this.formAdd.field3Title =
              this.formAdd.field3Title.length > 0
                ? JSON.stringify(this.formAdd.field3Title)
                  .trim()
                  .replace(/(\r\n|\n|\r)/gm, '')
                  .replace(/'/g, "\\'")
                  .replace(/"/g, '\\"')
                  .replace(/%/g, '%%')
                : ''

            this.formAdd.field4Title =
              this.formAdd.field4Title.length > 0
                ? JSON.stringify(this.formAdd.field4Title)
                  .trim()
                  .replace(/(\r\n|\n|\r)/gm, '')
                  .replace(/'/g, "\\'")
                  .replace(/"/g, '\\"')
                  .replace(/%/g, '%%')
                : ''
            //
            this.formAdd.answerChoice = null
          }
          console.log('stringify3', this.formAdd)
          await axios
            .post(this.DNS_IP + this.path + 'add', this.formAdd)
            .then(async (response) => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog

              console.log(this.formAdd)
              console.log('stringify4', this.formAdd.answerChoice)
              // this.dataShowQR = true
              // this.dialogViewAdd = true

              // Load Data
              console.log(
                'this.formAdd.answerChoice',
                this.formAdd.answerChoice
              )
              await this.getData()
              await this.clearDataAdd('add')
              this.loadingAdd = false
            })
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },

    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingEdit = true
          // this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.activityId
          this.formUpdateItem.title = this.formUpdate.title
          this.formUpdateItem.LAST_USER = this.session.data.userName
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)

            await axios
              .post(this.DNS_IP + `/file/upload/activity`, params)
              .then(function (response) {
                _this.formUpdateItem.pictureUrl = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdateItem.pictureUrl = this.formUpdate.pictureUrlPreview
          }
          // delete this.formUpdate['pictureUrlPreview']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + ID,
              this.formUpdateItem
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async (response) => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.getData()
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.activityId)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      //   this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      // this.deleteDataGlobal(
      //   this.DNS_IP,
      //   this.path,
      //   this.formUpdate.activityId,
      //   this.session.data.shopId,
      //   '',
      //   this.returnLink
      // )
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "delete/" + this.formUpdate.activityId,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              console.log('DNS_IP + PATH + "delete/"', response)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false

              // Load Data
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
      //   console.log(this.DNS_IP,
      //     this.path)
    },
    closeDialodActivity () {
      this.dialogAdd = false
      setTimeout(() => {
        this.clearDataAdd()
      }, 200)
    },
    clearDataActivity () {
      this.formAdd.field1Title = []
      this.formAdd.answerChoice = [['']]
      this.formAdd.field1Type = ''
      this.formAdd.field2Title = []
      this.formAdd.field2Type = ''
      this.formAdd.field3Title = []
      this.formAdd.field3Type = ''
      this.formAdd.field4Title = []
      this.formAdd.field4Type = ''
      this.formAdd.Primary_field = ''
      this.formAdd.chkbox1 = false
      this.formAdd.chkbox2 = false
      this.formAdd.chkbox3 = false
      this.formAdd.chkbox4 = false
      this.answerChoiceEng = [['']]
    },
    async clearDataAdd (item) {
      if (item === 'add') {
        this.dialogAdd = false
      }
      this.typeExpire = 'มีวันสิ้นสุดกิจกรรม'
      this.loadingInsert = false
      this.formAdd.activityId = ''
      this.formAdd.title = ''
      this.formAdd.titleEng = ''
      this.formAdd.type = null
      this.formAdd.answerType = 'คำตอบแบบข้อความ'
      this.formAdd.repeats = ''
      this.formAdd.startDate = ''
      this.formAdd.endDate = ''
      this.formAdd.quota = ''
      this.formAdd.coin = 0
      this.formAdd.field1Title = []
      this.formAdd.answerChoice = [['']]
      this.formAdd.field1Type = ''
      this.formAdd.field2Title = []
      this.formAdd.field2Type = ''
      this.formAdd.field3Title = []
      this.formAdd.field3Type = ''
      this.formAdd.field4Title = []
      this.formAdd.field4Type = ''
      this.formAdd.Primary_field = ''
      this.formAdd.chkbox1 = false
      this.formAdd.chkbox2 = false
      this.formAdd.chkbox3 = false
      this.formAdd.chkbox4 = false
      this.formAdd.shopId = ''
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.pictureUrl = ''
      this.formAdd.pictureUrlPreview = ''
      this.filesAdd = null
      this.answerChoiceEng = [['']]
      this.inline = 'จำกัดจำนวนคนเข้าร่วม'
      this.secoundStep = null
      this.thirdStep = false
      this.countQuestion = 1

      this.selectType = [
        {
          text: 'ตอบคำถามรับคะแนน',
          value: 'กรอกข้อมูล',
          icon: 'mdi-message-question',
          color: 'grey'
        },
        {
          text: 'รับคะแนน ฟรี!',
          value: 'FreeCoin',
          icon: 'mdi-alpha-c-circle-outline',
          color: 'grey'
        }
      ]
      if (this.$refs.form_add) {
        this.$refs.form_add.resetValidation()
      }
      if (this.$refs.form_add2) {
        this.$refs.form_add2.resetValidation()
      }
    },
    clearData2 () {
      if (this.countQuestion === 2) {
        this.formAdd.field2Title = ''
        this.formAdd.field2Type = ''
        this.formAdd.chkbox2 = false
      } else if (this.countQuestion === 3) {
        this.formAdd.field2Title = this.formAdd.field3Title
        this.formAdd.field2Type = this.formAdd.field3Type
        this.formAdd.chkbox2 = this.formAdd.chkbox3
        this.formAdd.field3Title = ''
        this.formAdd.field3Type = ''
        this.formAdd.chkbox3 = false
      } else if (this.countQuestion === 4) {
        this.formAdd.field2Title = this.formAdd.field3Title
        this.formAdd.field2Type = this.formAdd.field3Type
        this.formAdd.field3Title = this.formAdd.field4Title
        this.formAdd.field3Type = this.formAdd.field4Type
        this.formAdd.chkbox2 = this.formAdd.chkbox3
        this.formAdd.chkbox3 = this.formAdd.chkbox4
        this.formAdd.field4Title = ''
        this.formAdd.field4Type = ''
        this.formAdd.chkbox4 = false
      }
    },
    clearData3 () {
      if (this.countQuestion === 3) {
        this.formAdd.field3Title = ''
        this.formAdd.field3Type = ''
        this.formAdd.chkbox3 = false
      } else if (this.countQuestion === 4) {
        this.formAdd.field3Title = this.formAdd.field4Title
        this.formAdd.field3Type = this.formAdd.field4Type
        this.formAdd.chkbox3 = this.formAdd.chkbox4
        console.log('this.formAdd.field3Title', this.formAdd.field3Title)
        this.formAdd.field4Title = ''
        this.formAdd.field4Type = ''
        this.formAdd.chkbox4 = false
      }
    },
    clearData4 () {
      this.formAdd.field4Title = ''
      this.formAdd.field4Type = ''
      this.formAdd.chkbox4 = false
    }
  }
}
</script>
<style scoped>
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 18px;
}
.point {
  font-size: 30px;
  font-weight: bold;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#margin {
  margin-top: 30px;
  margin-bottom: 50px;
}
.iconja {
  font-size: 50px !important;
}
.v-card--link:focus::before {
  opacity: 0;
}
.not-activeCard {
  border-radius: 15px !important;
  text-align: center;
  background-color: #f7f8fc !important;
  border: 2px solid #f7f8fc;
  padding-bottom: 8px;
  padding-top: 8px;
}
.activeCard {
  border-radius: 15px !important;
  text-align: center;
  background-color: white;
  border: 2px solid #1b437c !important;
  padding-bottom: 8px;
  padding-top: 8px;
  transform: translateY(-10px);
  box-shadow: 0px 10px 20px 2px rgba(0, 0, 0, 0.25);
  transition: all ease 0.5s;
}
.not-activeCard:hover {
  transition: all ease 0.5s;
  transform: translateY(-5px);
  background-color: white;
}
.image-input {
  display: block;
  width: 250px;
  height: 250px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.placeholder {
  background: #f0f0f0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
}
.answer {
  margin-bottom: 2px !important;
  padding: 9px !important;
  text-align: center !important;
  transition: all ease 0.4s !important;
  display: flex !important;
  justify-content: space-between !important;
  font-size: 15px !important;
  border-radius: 10px !important;
}
.answer2 {
  margin-bottom: 2px !important;
  text-align: center !important;
  transition: all ease 0.4s !important;
  display: flex !important;
  justify-content: space-between !important;
  padding: 9px !important;
  font-size: 15px !important;
  border-radius: 10px !important;
}
/* .v-input--radio-group--row .v-input--radio-group__input {
  justify-content: space-between;
} */
</style>



// WEBPACK FOOTER //
// src/components/Tool/Activity.vue